// Device detection utilities
export const getDeviceType = (): 'ios' | 'android' | 'desktop' => {
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

  // iOS detection
  if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
    return 'ios';
  }

  // Android detection
  if (/android/i.test(userAgent)) {
    return 'android';
  }

  return 'desktop';
};

// App store URLs
const APP_STORE_URL = 'https://apps.apple.com/us/app/scorebuzzer/id1493170946';
const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.scorer.scorebuzzer';
const SCOREBUZZER_HOMEPAGE = 'https://home.scorebuzzer.com';

// Link handlers
export const handleLearnMoreClick = () => {
  window.open(`${SCOREBUZZER_HOMEPAGE}#streaming-plans`, '_blank', 'noopener,noreferrer');
};

export const handleStartForFreeClick = () => {
  const deviceType = getDeviceType();

  switch (deviceType) {
    case 'ios':
      window.open(APP_STORE_URL, '_blank', 'noopener,noreferrer');
      break;
    case 'android':
      window.open(GOOGLE_PLAY_URL, '_blank', 'noopener,noreferrer');
      break;
    case 'desktop':
      // Open homepage and scroll to download section
      const homepage = window.open(SCOREBUZZER_HOMEPAGE, '_blank', 'noopener,noreferrer');
      // Note: We can't scroll to a specific section in a new window due to security restrictions
      // The homepage should have a prominent download section visible
      break;
  }
};

// Check if device should show desktop or mobile promo
export const shouldShowDesktopPromo = (windowWidth: number, isMultiColumnLayout: boolean): boolean => {
  // Desktop footer: >= 1024px
  if (windowWidth >= 1024) {
    return true;
  }

  // Mobile card: < 768px
  if (windowWidth < 768) {
    return false;
  }

  // Between 768px and 1023px: check if multi-column layout
  return isMultiColumnLayout;
};
